<template>
  <div class="modal fade" id="modalSubscriptionDetail" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Detalhes e nova fatura.</h4>
        </div>

        <div class="modal-body">
          <!-- Loading -->
          <div v-if="loadingListModal" class="loading center_vertical">
            <div class="loader-mini-box">
              <div class="spinner-box">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>

          <!-- Tabela -->
          <div v-if="!loadingListModal">
            <div class="modal-table">
              <div class="detail-info">
                <h5><span>Detalhes da fatura:</span></h5>
                <p>Empresa:
                  <span>
                  <a v-if="dataDetail.companyId && dataDetail.contextCode"
                     v-bind:href="'/detalhes-da-empresa/' + dataDetail.companyId + '/' + dataDetail.contextCode"
                     target="_blank" title="Visualizar" class="link">{{ dataDetail.name }}</a>
                </span>
                </p>
                <p v-if="dataDetail.employees">Total de funcionários: <span>{{ dataDetail.employees }}</span></p>
                <p v-if="dataDetail.pricePerEmployee">Preço por funcionário:
                  <span>R$ {{ dataDetail.pricePerEmployee }}</span></p>
                <p v-if="dataDetail.discount">Desconto: <span>R$ {{ dataDetail.discount }}</span></p>
                <p v-if="dataDetail.subscriptionPaymentHistoryStatusStr">Status:
                  <span>{{ dataDetail.subscriptionPaymentHistoryStatusStr }}</span></p>
                <p v-if="dataDetail.paidAt">Pago em: <span>{{ dataDetail.paidAt | formatFullDate }}</span></p>

                <p v-if="dataDetail.totalCos">Custo total: <span>R$ {{ dataDetail.totalCost }}</span></p>
                <p v-if="dataDetail.totalPaid">Total pago: <span>R$ {{ dataDetail.totalPaid }}</span></p>
                <p>Boleto:
                  <span v-if="dataDetail.bankSlipUri"><a v-bind:href="dataDetail.bankSlipUri" target="_blank"
                                                         title="Visualizar" class="link">Visualizar Boleto</a></span>
                  <span v-if="!dataDetail.bankSlipUri">Nenhum boleto cadastrado.</span>
                </p>
              </div>

              <div class="detail-form">
                <h5><span>Gerar nova fatura:</span></h5>
                <div class="input-group input-with-date">
                  <label>Data de vencimento</label>
                  <datepicker ref="programaticOpen3" v-model="expireAt" :language="ptBR" :format="customFormatter"/>
                  <i v-on:click="openCalendar()" class="fa fa-calendar" aria-hidden="true"></i>
                  <span v-if="dataError.date" class="error-msg">{{ dataError.date }}</span>
                </div>

                <div class="form-group">
                  <label for="value">Valor</label>
                  <input v-model.lazy="price" v-money="money" type="text" class="form-control" id="value" name="value"/>
                  <span v-if="dataError.price" class="error-msg">{{ dataError.price }}</span>
                </div>

                <div class="form-group">
                  <label for="description">Descrição</label>
                  <textarea v-model="dataCode.description" class="form-control" id="description"
                            name="description"></textarea>
                </div>

                <button v-on:click="confirmCancelSubs();" :disabled="loadingCancel"
                        v-bind:class="{'disable': loadingCancel}" type="submit" class="btn default-btn-red">
                  <span v-if="!loadingCancel">Cancelar</span>
                  <div class="loadingSend" v-else>
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>
                <button v-on:click="registerBillet()" :disabled="loadingSend" v-bind:class="{'disable': loadingSend}"
                        type="submit" class="btn default-btn-bue">
                  <span v-if="!loadingSend">Gerar</span>
                  <div class="loadingSend" v-else>
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>

                <div class="list-error">
                  <span v-if="invalidReason.length" v-for="iv in invalidReason" class="error-msg">{{ iv }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PAYMENT_HISTORIES_M_DUPLICATE,
  PAYMENT_HISTORIES_M_DETAIL,
  GET_INVOICE,
  PAYMENT_HISTORIES_S_DETAIL_CANCEL,
  COMPANY_PAYMENT_INFO
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import {
  VMoney
} from "v-money";
import datepicker from "vuejs-datepicker";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import swal from "sweetalert";

export default {
  name: "modalSubscriptionDetail",
  props: ['callCheckRequest'],
  directives: {
    money: VMoney
  },
  components: {
    datepicker,
  },
  data() {
    return {
      ptBR: ptBR,
      loadingListModal: '',
      context: '',
      dataError: {
        date: '',
        price: ''
      },
      dataValue: {},
      dataDetail: {
        companyId: '',
        contextCode: '',
      },
      dataCode: {
        expireAt: '',
        price: '',
        description: ''
      },
      dataPaymentCompany: {},
      invalidReason: [],
      loadingSend: false,
      loadingCancel: false,
      expireAt: '',
      price: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    getContext() {
      this.dataDetail.contextCode = this.$route.params.context;
    },
    getPaymentInfoDetails() {
      this.loading = true;
      let url = COMPANY_PAYMENT_INFO + "?t=kkkk&i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_PAYMENT_INFO:", response.data);

          this.dataPaymentCompany = response.data;

        })
        .catch((reason) => {
          this.loading = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    firstPaymentValue() {

      for (let index in this.dataPaymentCompany.payments) {
        if (this.dataPaymentCompany.payments[index].id == this.dataDetail.id) {
          if (this.dataPaymentCompany.payments[index].firstPayment) {
            return true
          }

          return false
        }
      }

    },
    confirmCancelSubs() {

      let valueFirstPayment = this.firstPaymentValue();

      if (valueFirstPayment === true && this.dataDetail.subscriptionPaymentHistoryStatusStr == 'Pendente') {
        swal({
          title: "Cancelar fatura",
          text: "Essa fatura pertence a uma emissão de VENDAS, deseja cancelar a assinatura e o boleto?",
          icon: "warning",
          buttons: ["Não", "Sim"],
          dangerMode: true,
        })
          .then((willDelete) => {
            if (willDelete) {
              this.cancelSubsSubscription();
            } else {
              this.cancelSubs();
            }
          });
      } else {
        this.cancelSubs();
      }
    },
    cancelSubs: function () {
      if (!this.loadingCancel) {
        this.loadingCancel = true;

        REQUEST_SERVICE.requestContext("GET", PAYMENT_HISTORIES_S_DETAIL_CANCEL + this.dataDetail.id, this.dataDetail.contextCode).then((response) => {
          UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_S_DETAIL_CANCEL:", response.data);

          $('#modalSubscriptionDetail').modal('toggle');

          ALERT_SERVICE.swal("Aviso", response.data, "success");
          this.loadingCancel = false;
        }).catch((reason) => {
          this.loadingCancel = false;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
    cancelSubsSubscription: function () {
      if (!this.loadingCancel) {
        this.loadingCancel = true;

        let valueFirstPayment = '?subscription=True';

        REQUEST_SERVICE.requestContext("GET", PAYMENT_HISTORIES_S_DETAIL_CANCEL + this.dataDetail.id + valueFirstPayment, this.dataDetail.contextCode).then((response) => {
          UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_S_DETAIL_CANCEL:", response.data);

          $('#modalSubscriptionDetail').modal('toggle');

          ALERT_SERVICE.swal("Aviso", response.data, "success");
          this.loadingCancel = false;
        }).catch((reason) => {
          this.loadingCancel = false;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
    openCalendar: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    closeModal() {
      $('#modalSubscriptionDetail').modal('toggle');
    },
    geDetail(id) {
      this.loadingListModal = true;

      let url = PAYMENT_HISTORIES_M_DETAIL + id;

      REQUEST_SERVICE.requestContext("GET", url, this.dataDetail.contextCode)
        .then((response) => {
          UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_M_DETAIL:", response.data);

          this.loadingListModal = false;
          if (response.data) {
            this.dataDetail = response.data;
          }
        }).catch((reason) => {
        this.loadingListModal = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    registerBillet() {
      if (!this.loadingSend) {
        this.dataError = {
          date: '',
          price: ''
        };
        this.invalidReason = [];
        if (this.expireAt && this.price) {
          this.loadingSend = true;
          this.dataCode.id = this.dataValue.id;
          this.dataCode.price = this.price.replace("R$ ", "");
          this.dataCode.expireAt = moment(this.expireAt).format("YYYY-MM-DD");

          UTIL_SERVICE.console("DATA SEND:", this.dataCode);

          REQUEST_SERVICE.requestContext("POST", PAYMENT_HISTORIES_M_DUPLICATE, this.dataDetail.contextCode, this.dataCode).then((response) => {
            UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_M_DUPLICATE:", response.data);

            $('#modalSubscriptionDetail').modal('toggle');

            ALERT_SERVICE.swal("Aviso", 'Fatura cancelada com sucesso.', "success");
            this.loadingSend = false;
            setTimeout(() => {
              location.reload();
            }, 1500);
          }).catch((reason) => {
            reason.response.data.erros.map((value, index) => {
              this.invalidReason.push(value.value);
            });

            this.loadingSend = false;
          });
        } else {
          if (!this.expireAt) {
            this.dataError.date = "Campo obrigatório.";
          }
        }
      }
    }
  },
  watch: {
    callCheckRequest: function (val) {
      this.dataError = {
        date: '',
        price: ''
      };
      this.invalidReason = [];
      this.expireAt = '';
      this.price = 0;
      this.dataCode = {
        expireAt: '',
        price: '',
        description: ''
      };

      this.dataValue = val;
      this.dataPaymentCompany = val.dataCompany;
      this.geDetail(val.id);
    }
  },
  beforeMount() {
    // this.getPaymentInfoDetails();
    this.getContext();
  }
}
</script>

<style lang="scss">
.swal-overlay {
  z-index: 10050 !important;
}

#modalSubscriptionDetail {
  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .list-error {
    margin-top: 10px;

    .error-msg {
      display: block;
    }
  }

  @media (min-width: 768px) {
    .modal-dialog {
      width: 1000px;
      margin: 30px auto;
    }
  }

  .loader-mini-box {
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .spinner-box {
      height: 64px;
      text-align: center;

      .rect2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
      }

      .rect3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
      }

      .rect4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
      }

      .rect5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
      }

      > div {
        background-color: #3598dc;
        width: 4px;
        height: 64px;
        display: inline-block;
        -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
        animation: sk-stretchdelay 1.2s infinite ease-in-out;
        margin-right: 4px;
      }
    }
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .double-btn-center {
    display: block;
    margin: 0 auto 50px;

    .first {
      background: #00a651;
      color: #fff;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #008d45;
      }
    }

    .second {
      background: #0F77AE;
      color: #fff;
      width: 49%;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #054F91;
      }
    }

    .third {
      background: #c29d0b;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #aa890a;
      }
    }

    .four {
      background: #e74a4e;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #e43338;
      }
    }
  }

  .send-btn-modal {
    background: #3598dc;
    color: #fff;
    border: none;
    padding: 0 15px;
    height: 37px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto 0 0;

    &:hover {
      background-color: #054F91;
    }
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;

    .detail-info {
      display: inline-block;
      width: 49%;
      min-height: 330px;

      h5 {
        margin: 0;

        span {
          margin: 0;
          font-weight: bold;
          letter-spacing: 1px;
          text-transform: uppercase;
          border-bottom: 1px solid;
          padding: 0 4px;
        }
      }

      p {
        span {
          font-weight: 600;
        }
      }
    }

    .detail-form {
      display: inline-block;
      width: 49%;
      float: right;

      h5 {
        margin: 0 0 20px;

        span {
          margin: 0;
          font-weight: bold;
          letter-spacing: 1px;
          text-transform: uppercase;
          border-bottom: 1px solid;
          padding: 0 4px;
        }
      }

      .form-group {
        margin-top: 15px;
      }
    }
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalSubscriptionDetail.vue